import React, { useEffect, useState } from 'react';
import { Space, Modal, Checkbox } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { BasicFormWrapper } from '../../pages/styled';
import { Button } from '../buttons/buttons';
import { getItem, setItem } from '../../utility/localStorageControl';

const TableColumnManager = ({ allColumns, onSave, defaultSelected, saveKey, title, open }) => {
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [columns, setColumns] = useState(allColumns);

    useEffect(() => {
        if (open) {
            const initialSelected = getItem(saveKey) || defaultSelected || [];
            setSelectedColumns(initialSelected);
            setColumns(allColumns);
        }
    }, [open, allColumns, defaultSelected, saveKey]);

    console.log('key select', saveKey);

    const onColumnChange = (e, column) => {
        const updated = e.target.checked
            ? [...selectedColumns, column.dataIndex]
            : selectedColumns.filter((col) => col !== column.dataIndex);

        setSelectedColumns([...new Set(updated)]);
    };

    const handleSave = () => {
        setItem(saveKey, selectedColumns);
        onSave(selectedColumns);
    };

    const handleCancel = () => {
        onSave(null); // just close the modal
    };
    const isAllSelected = selectedColumns.length === allColumns.length;

    const DragHandle = SortableHandle(() => <FeatherIcon icon="align-justify" size={16} />);

    const SortableItem = SortableElement(({ column }) => (
        <Space
            align="center"
            direction="horizontal"
            style={{
                background: '#f9f9f9',
                border: '1px solid #ddd',
                borderRadius: 4,
                width: '100%',
                padding: '0.6rem',
            }}
        >
            <DragHandle />
            <Checkbox checked={selectedColumns.includes(column.dataIndex)} onChange={(e) => onColumnChange(e, column)}>
                {column.title}
            </Checkbox>
        </Space>
    ));

    const SortableList = SortableContainer(({ items }) => (
        <Space direction="vertical" size="small" style={{ marginBottom: '3rem', width: '100%' }}>
            {items.map((column, index) => (
                <SortableItem key={column.dataIndex} index={index} column={column} />
            ))}
        </Space>
    ));

    return (
        <Modal title={title} open={open} footer={null} onCancel={handleCancel}>
            <BasicFormWrapper>
                <Space direction="horizontal" align="baseline" size="small">
                    {/* Master “Select all” checkbox */}
                    <Checkbox
                        style={{ marginBottom: '1rem', padding: '0.6rem' }}
                        checked={isAllSelected}
                        indeterminate={false}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectedColumns(allColumns.map((col) => col.dataIndex));
                            } else {
                                setSelectedColumns([]);
                            }
                        }}
                    >
                        Select all
                    </Checkbox>

                    {/* Reset button */}
                    <Button
                        type="primary"
                        outlined
                        size="extra-small"
                        icon={<FeatherIcon icon="refresh-cw" size={16} />}
                        onClick={() => {
                            const stored = getItem(saveKey) || defaultSelected || [];
                            setSelectedColumns(stored);
                        }}
                    >
                        Reset
                    </Button>
                </Space>

                <style>{`
                    .sortable-helper {
                        z-index: 999999 !important;
                        opacity: 1 !important;
                    }
                `}</style>

                {/* Sortable list of individual columns */}
                <SortableList
                    items={columns}
                    onSortEnd={({ oldIndex, newIndex }) => {
                        const updated = arrayMove(columns, oldIndex, newIndex);
                        setColumns(updated);
                    }}
                    useDragHandle
                    helperClass="sortable-helper"
                />

                {/* Footer buttons */}
                <div className="sDash_form-action">
                    <Button size="default" type="light" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button size="default" type="primary" onClick={handleSave}>
                        Save
                    </Button>
                </div>
            </BasicFormWrapper>
        </Modal>
    );
};

export default TableColumnManager;
